import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["classes", "field", "message"];
import React, { Fragment } from 'react';
import { number, node, oneOf, oneOfType, shape, string } from 'prop-types';
import { TextArea as InformedTextArea } from 'informed';
import useFieldState from '@magento/peregrine/lib/hooks/hook-wrappers/useInformedFieldStateWrapper';
import { useStyle } from '../../classify';
import { Message } from '../Field';
import defaultClasses from './textArea.module.css';

var TextArea = function TextArea(props) {
  var propClasses = props.classes,
      field = props.field,
      message = props.message,
      rest = _objectWithoutProperties(props, _excluded);

  var fieldState = useFieldState(field);
  var classes = useStyle(defaultClasses, propClasses);
  return React.createElement(Fragment, null, React.createElement(InformedTextArea, _extends({}, rest, {
    className: classes.input,
    field: field
  })), React.createElement(Message, {
    fieldState: fieldState
  }, message));
};

export default TextArea;
TextArea.defaultProps = {
  cols: 40,
  rows: 4,
  wrap: 'hard'
};
TextArea.propTypes = {
  classes: shape({
    input: string
  }),
  cols: oneOfType([number, string]),
  field: string.isRequired,
  message: node,
  rows: oneOfType([number, string]),
  wrap: oneOf(['hard', 'soft'])
};